import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { LinkButton } from '../ui/Button';
import { company } from '../../data/site';
const ease = [0.23, 1, 0.32, 1] as const;
const tagline = ['Multiservice', 'Montage', 'Vedligehold'];
export function Hero() {
  return <section id="top" className="scroll-mt-24" data-id="element-104" data-mp="hvqpk2k9k32o">
      <div className="bg-white" data-id="element-105" data-mp="mu0lifdtb7pc">
        <div className="mx-auto grid max-w-content items-center gap-10 px-5 py-14 md:py-20 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16 lg:px-8" data-id="element-106" data-mp="mutu7lwc07a4">
          <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.45,
          ease
        }} className="flex justify-center lg:justify-start" data-id="element-107" data-mp="qtj77ddgjmt8">
            <h1 data-id="element-108" data-mp="15l1uzxck6ln5">
              <img src={company.logo} alt="LYKKEVÆRK — multiservice, håndværk og vedligehold" className="h-44 w-auto max-w-full sm:h-52 md:h-64 lg:h-72" data-id="element-109" data-mp="15ll18gsujllc" />
            </h1>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45,
          ease,
          delay: 0.08
        }} data-id="element-110" data-mp="4optqa82e77t">
            <ul className="flex flex-wrap items-center gap-x-4 gap-y-2 font-display text-lg font-bold tracking-tight text-ink md:text-2xl" data-id="element-111" data-mp="3vx3pv4t33raq">
              {tagline.map((item, index) => <li key={item} className="flex items-center gap-4" data-id="element-112" data-mp="sdir8b4c4n4j" data-mpi={index}>
                  {index > 0 && <span className="h-1.5 w-1.5 rounded-full bg-accent" aria-hidden="true" data-id="element-113" data-mp="nfr2tr2wfj53" />}
                  {item}
                </li>)}
            </ul>

            <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink-soft md:text-xl" data-id="element-114" data-mp="enp540k7sgyi">
              Praktiske løsninger til private og virksomheder. Har du en opgave, stor eller lille, så kontakt
              LYKKEVÆRK og få en uforpligtende snak.
            </p>

            <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-115" data-mp="30lxdm9z3wawp">
              <LinkButton href="#kontakt" size="lg" data-id="element-116" data-mp="30mp9zn0j2co1">
                Få et tilbud
              </LinkButton>
              <LinkButton href={company.phoneHref} variant="secondary" size="lg" data-id="element-117" data-mp="35n37ib4i647t">
                Kontakt LYKKEVÆRK
              </LinkButton>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="bg-ink" data-id="element-118" data-mp="2vsuhpv6uwpdc">
        <div className="mx-auto flex max-w-content flex-col gap-5 px-5 py-7 md:flex-row md:items-center md:justify-between md:py-8 lg:px-8" data-id="element-119" data-mp="2huwgzslgkrgb">
          <a href={company.phoneHref} className="flex items-center gap-3 font-display text-2xl font-bold tracking-tight text-white transition-colors duration-200 ease-smooth hover:text-accent md:text-3xl" data-id="element-120" data-mp="2mw3n7n7ydikv">
            <PhoneIcon className="h-5 w-5 shrink-0 text-accent" strokeWidth={1.75} aria-hidden="true" data-id="element-121" data-mp="664xzal1i6v4" />
            {company.phone}
          </a>

          <div className="flex flex-col gap-3 text-[15px] text-white/80 sm:flex-row sm:items-center sm:gap-8" data-id="element-122" data-mp="b3oksyvszryo">
            <a href={`mailto:${company.email}`} className="flex items-center gap-2.5 break-all transition-colors duration-200 ease-smooth hover:text-white" data-id="element-123" data-mp="1vnaa2xy7v1un">
              <MailIcon className="h-4 w-4 shrink-0 text-accent" strokeWidth={1.75} aria-hidden="true" data-id="element-124" data-mp="25e4x44jae5h5" />
              {company.email}
            </a>
            <p className="flex items-center gap-2.5" data-id="element-125" data-mp="2ecz0qev1bw47">
              <ClockIcon className="h-4 w-4 shrink-0 text-accent" strokeWidth={1.75} aria-hidden="true" data-id="element-126" data-mp="2ebp2npo6mnxk" />
              Svar normalt samme dag
            </p>
            <p className="text-white/50" data-id="element-127" data-mp="2oby1lb9k6ngn">CVR: {company.cvr}</p>
          </div>
        </div>
      </div>
    </section>;
}